import React, {useState,useEffect} from "react";
import MenuIcon from '@material-ui/icons/Menu';
import List from '@material-ui/core/List';
import {Divider, ListItem} from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSearch, faUser, faChevronRight} from '@fortawesome/free-solid-svg-icons'
import {ApiProviderContext} from "../providers/ApiProvider";
import {Dropdown} from "react-bootstrap";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {useHistory} from "react-router-dom";
import Drawer from '@material-ui/core/Drawer';
import {ShowAt, HideAt} from "react-with-breakpoints";


const menuList = [
    {name: 'Anasayfa', route: '/', icon: "", className:""},
    {name: 'Randevu Sorgula', route: '', icon: <FontAwesomeIcon icon={faSearch}/>, className: "btn btn-secondary"},

    // {name: 'İletişim', route: '/iletisim'},

]

function TopBar(){






useEffect(() => {
    // Inject the GTM script
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NX7GPH4W');
    `;
    document.head.appendChild(script);

    // Inject the noscript iframe
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NX7GPH4W"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.insertBefore(noscript, document.body.firstChild);

    // Cleanup function to remove the scripts when the component unmounts
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);











    let history = useHistory();
    const loginProvider = React.useContext(ApiProviderContext)!

    let [openMenu, setOpenMenu] = useState<boolean>(false);
    let [openAccountMenu, setOpenAccountMenu] = useState<boolean>(false);
    let [popover, setPopover] = useState(false);

    function logout(){
        loginProvider.logout();
    }

    return (
        <header className="header">
            <div className="d-none d-md-block">
                <div className="container pl-2 pl-md-0 pr-2 pr-md-0 py-1">
                    <div className="d-flex justify-content-start align-items-center">
                        <div className="">
                            <a href="https://carringoservis.com/" target="_blank"><img src="/carringo-logo-new.png" height={60} loading={"lazy"}/></a>
                        </div>
                        <div className="flex-fill">
                            <div className="justify-content-end d-flex align-items-center">
                                {/*<div key={"menu-ask-appointment"} className="ml-4 ">*/}
                                {/*    <a  href={"/"} className={"nav-list-item text-decoration-none "}>Randevu Al</a>*/}
                                {/*</div>*/}

                                {/*<div key={"menu-ask-appointment"} className="ml-4 ">*/}
                                {/*    <a  href={"/check-appointment"} target="_blank" className={"nav-list-item text-decoration-none "}>Randevu Sorgula <FontAwesomeIcon icon={faSearch}/></a>*/}
                                {/*</div>*/}

                                <div key={"menu-ask-appointment"} className="ml-4 ">
                                    <a  href={"https://carringoservis.com/"} className={"nav-list-item text-decoration-none btn btn-secondary btn-sm "}>Web sitesine git <FontAwesomeIcon icon={faChevronRight}/></a>
                                </div>

                                {/*{loginProvider?.isLogin === true ? (*/}
                                {/*    <>*/}
                                {/*        <div key={"menu-my-account"} className="ml-4 ">*/}
                                {/*            <Dropdown>*/}
                                {/*                <Dropdown.Toggle variant="secondary" id="dropdown-basic" className=" d-flex justify-content-start align-items-center">*/}
                                {/*                    <AccountCircleIcon className="text-orange"/><span className="mx-1 ">Hesabım</span><small className="">({loginProvider?.user?.username})</small>*/}
                                {/*                </Dropdown.Toggle>*/}
                                {/*                <Dropdown.Menu alignRight={true}>*/}
                                {/*                    <Dropdown.Item href="/my-appointments">Randevularım</Dropdown.Item>*/}
                                {/*                    <Dropdown.Item href="/profile">Profil</Dropdown.Item>*/}
                                {/*                    <Dropdown.Item onClick={() => logout()}>Çıkış</Dropdown.Item>*/}
                                {/*                </Dropdown.Menu>*/}
                                {/*            </Dropdown>*/}
                                {/*        </div>*/}
                                {/*    </>*/}
                                {/*) : (*/}
                                {/*    <>*/}
                                {/*        <div key={"menu-ask-appointment"} className="ml-4 ">*/}
                                {/*            <a  href={"check-appointment"} className={"nav-list-item text-decoration-none "}>Randevu Sorgula</a>*/}
                                {/*        </div>*/}
                                {/*        <div key={"menu-register"} className="ml-4 ">*/}
                                {/*            <a  href={"/register"} className={"nav-list-item text-decoration-none "}>Yeni Üyelik</a>*/}
                                {/*        </div>*/}
                                {/*        <div key={"menu-login"} className="ml-4 ">*/}
                                {/*            <a  href={"/login"} className={"nav-list-item text-decoration-none "}>Giriş Yap</a>*/}
                                {/*        </div>*/}
                                {/*    </>*/}
                                {/*)}*/}

                            </div>
                            {/*{loginProvider.isLogin === true ? (*/}
                            {/*    <AccountCircleIcon onClick={() => setOpenAccountMenu(!openAccountMenu)} className="text-orange float-right d-md-none d-block" fontSize={"large"} />*/}
                            {/*) : (*/}
                            {/*    <PersonOutlineIcon onClick={() => history.push('/login')} className="text-white float-right d-md-none d-block" fontSize={"large"} />*/}
                            {/*)}*/}

                        </div>
                    </div>
                </div>
            </div>
            <div className="d-block d-md-none">
                <div className="container pl-2 pl-md-0 pr-2 pr-md-0 py-1">
                    <div className="d-flex justify-content-start align-items-center">
                        {/*{loginProvider.isLogin === false && (*/}
                        {/*    <MenuIcon onClick={() => setOpenMenu(!openMenu)} className="text-white float-right " fontSize={"large"} />*/}
                        {/*)}*/}

                        <div className="ml-2">
                            <a href="https://carringoservis.com/" target="_blank"><img src="/carringo-logo-new.png" height={40} loading={"lazy"}/></a>
                        </div>
                        {/*<div className="flex-fill">*/}
                        {/*    {loginProvider.isLogin === true ? (*/}
                        {/*        <AccountCircleIcon onClick={() => setOpenAccountMenu(!openAccountMenu)} className="text-orange float-right" fontSize={"large"} />*/}
                        {/*    ) : (*/}
                        {/*        <PersonOutlineIcon onClick={() => history.push('/login')} className="text-white float-right " fontSize={"large"} />*/}
                        {/*    )}*/}

                        {/*</div>*/}
                    </div>
                </div>
                <div className="bg-white ">
                    <Drawer open={openMenu} className="" onClose={() => setOpenMenu(false)}>
                        <div className="bg-primary py-1 pl-2">
                            <a href="https://carringoservis.com/" target="_blank"><img src="/carringo-logo-new.png" height={40} loading={"lazy"}/></a>
                        </div>
                        <List component="nav" className="pt-1 mobile-menu">
                            <div key={"menu-register"} className="pb-1 pt-1">
                                <ListItem component={"a"} href={"/"} button>
                                    Anasayfa
                                </ListItem>
                                <Divider variant="fullWidth" component="li" />
                            </div>

                            <div key={"menu-register"} className="pb-1 pt-1">
                                <ListItem component={"a"} href={"/check-appointment"} button>
                                    Randevu Sorgula
                                </ListItem>
                                <Divider variant="fullWidth" component="li" />
                            </div>
                            <div key={"menu-register"} className="pb-1 pt-1">
                                <ListItem component={"a"} href={"/register"} button>
                                    Yeni Üyelik
                                </ListItem>
                                <Divider variant="fullWidth" component="li" />
                            </div>
                            <div key={"menu-register"} className="pb-1 pt-1 d-flex justify-content-between">
                                <ListItem component={"a"} href={"/login"} button>
                                    Giriş Yap
                                </ListItem>
                            </div>
                        </List>
                    </Drawer>
                    <Drawer  anchor={"right"} open={openAccountMenu} className="" onClose={() => setOpenAccountMenu(false)}>
                        <div className="bg-primary py-1 pl-2">
                            <a href="https://carringoservis.com/" target="_blank"><img src="/carringo-logo-new.png" height={40} loading={"lazy"}/></a>
                        </div>
                        <div className="px-3 py-1">
                            <AccountCircleIcon className="text-success"/> {loginProvider?.user?.username}
                        </div>
                        <List component="nav" className="pt-1 mobile-menu">
                            <div key={"menu-register"} className="pb-1 pt-1">
                                <ListItem component={"a"} href={"/my-appointments"} button>
                                    Randevularım
                                </ListItem>
                                <Divider variant="fullWidth" component="li" />
                                <ListItem component={"a"} href={"/profile"} button>
                                    Profil
                                </ListItem>
                                <Divider variant="fullWidth" component="li" />

                                <ListItem onClick={() => logout()} button>
                                    Çıkış Yap
                                </ListItem>
                            </div>

                        </List>
                    </Drawer>
                </div>

            </div>
        </header>
    )
}

export default TopBar;

